import styled from 'styled-components';
import { media } from '~src/styles/media-templates';

export const FeedbackCycleActions = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  align-items: center;
  z-index: 1;
  justify-content: flex-end;
  left: 0;
  top: 0;
  display: none;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 45%, #fff 60%, #e0e0e0 100%);
  padding-right: 30px;
  ${media.tablet`
    padding-right: 0;
  `}
`;

export const FeedbackCycleItemBoxContainer = styled.article`
  display: flex;
  position: relative;
  padding: 15px 30px;
  border-radius: 5px;
  background: ${({ theme }) => theme.white.a10};
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
  margin-bottom: 1rem;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  overflow: hidden;
  flex-wrap: nowrap;
  align-items: stretch;
  transform: perspective(1px) translateZ(0);
  backface-visibility: hidden;
  cursor: pointer;

  &:hover {
    box-shadow: 0 18px 20px 0 ${({ theme }) => theme.black.a2};
    z-index: 1;
    transform: scale(1.02, 1.02) perspective(1px) translateZ(0);

    ${FeedbackCycleActions} {
      display: flex;
    }
  }
`;

export const FeedbackCycleDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FeedbackCycleTitle = styled.h4`
  font-size: 1.4rem;
  margin-bottom: 10px;
  font-weight: 400;
  letter-spacing: 0.3px;
  color: rgba(78, 84, 107, 1);
  margin: 0;
`;

export const ActionItems = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 1;
`;

export const FeedbackCycleContent = styled.p`
  color: rgba(78, 84, 107, 0.6);
  margin-top: 12px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
